import { runValidation } from '@/core/validation/ValidationProcessor'
import {
	disablePrevValuesDictionarySupport,
	enablePrevValuesDictionarySupport
} from '@/core/support_gui_components/prevValuesDictionary/prevValuesDictionary'
import {
	clearMulticheckbox,
	disableMulticheckboxSupport,
	enableMulticheckboxSupport
} from '@/core/input_controls/multicheckbox/multicheckbox'
import { generateDifferentialJson } from '@/core/item_assistance/generatingDifferentialJson'
import { getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { bindImageAttributeEvents } from '@/core/input_controls/fileUploader/imageUploader'
import { initDatepicker } from '@/core/input_controls/datepicker/datepicker'
import { dataCapture } from '@/core/item_assistance/itemDataCapture'
import { flatDeepAttributes } from 'utils/format'

'use strict'

export function BatchUpdateManager (table, itemStructure, component) {

	let $data = undefined
	let itemIds = table.selectedItemsManager.getSelections()
	let $attrList = []

	let SELECTOR = {
		form: '#batch-update-form',
		content: '#batch-update-content',
		updateButton: '#batch-update-btn',
		cancelButton: '#batch-update-cancel',
		multicheckbox: '#batch-update-multicheckbox'
	}
	clearBinds()
	initMulticheckboxContent(component.$children[1].data.itemStructure)
	$data = component.$children[1].data
	clearContent()
	setBinds()
	showForm()

	function clearBinds () {
		$(SELECTOR.updateButton).unbind('click')
		$(SELECTOR.cancelButton).unbind('click')
		disablePrevValuesDictionarySupport()
		disableMulticheckboxSupport(SELECTOR.multicheckbox)
		// disableMulticheckboxSupport('.multicheckbox-editor.batch-update-editor')
	}

	function setBinds () {
		$(SELECTOR.updateButton).bind('click', batchUpdate)
		$(SELECTOR.cancelButton).bind('click', hideForm)
		enablePrevValuesDictionarySupport('#batch-update-form')
		enableMulticheckboxSupport({
			selector: SELECTOR.multicheckbox,
			updateCallback: switchEditorArea,
			selectAllCallback: selectAllCallback,
			clearCallback: clearContent,
			userData: $data
		})
	}

	function selectAllCallback () {
		let allAttr = Object.keys(itemStructure)
		$attrList = allAttr
		component.$children[1].$set(component.$children[1], 'attributeList', allAttr)
	}

	function batchUpdate () {
		var capturedData = {}
		let attributeListActions = JSON.parse(JSON.stringify(component.$children[1].intermediateAttributeList))
		dataCapture(itemStructure, capturedData, { parentSelector: SELECTOR.form })
		if (runValidation(capturedData, itemStructure, SELECTOR.form + ' .batch-update-editor')) {
			var attributesGroups = component.$store.getters.getAttributesGroups
			var allAttributesForGroups = flatDeepAttributes(attributesGroups)
			var changedData = generateDifferentialJson(capturedData, itemStructure, {}, allAttributesForGroups)

			for (let item in attributeListActions) {
				if (changedData.hasOwnProperty(item)) {
					changedData[item] = Object.assign({ value: changedData[item] }, attributeListActions[item])
				}
				if (!changedData.hasOwnProperty(item) && attributeListActions[item].action === 'REMOVE') {
					changedData[item] = Object.assign({}, attributeListActions[item])
				}
			}

			if (_.isEmpty(changedData)) {
				showMessageAlert(getLocalizedMessage('attributes.not.changed'), 'warning')
				hideForm()
				return false
			}

			$.ajax({
				type: 'POST',
				url: window.urlContext + 'items/extended-batch-update',
				data: {
					items: JSON.stringify(itemIds),
					changedData: JSON.stringify(changedData)
				},
				dataType: 'json',

				success: function (result) {
					if (result) {
						table.loadData()
						showMessageAlert(getLocalizedMessage('updated'), 'success')
					} else {
						showMessageAlert(getLocalizedMessage('error.saving'), 'danger')
					}
				},
				error: function (error) {
					showMessageAlert(getLocalizedMessage('error.saving'), 'danger')
					console.log(error)
				}
			})

			hideForm()
		} else {
			showMessageAlert(getLocalizedMessage('there.are.incorrect.data'), 'danger')
		}
	}

	function initMulticheckboxContent (itemStructure) {
		var $multicheckbox = $(SELECTOR.multicheckbox)
		if ($multicheckbox.length === 0) return false
		clearMulticheckbox($multicheckbox)

		var contentHtml = ''
		_.map(itemStructure, function (value, i) {
			if (!isKeyAttributeArea(i)) {
				contentHtml += '<li><input class="attribute-editor bg-editor" type="checkbox" value="' + i + '">' + getLocalizedMessage(value['title']) + '</li>'
			}
		})
		$multicheckbox.find('.checkbox-list').first().append(contentHtml)
	}

	function isKeyAttributeArea (area) {
		return $('#' + area).find('.primary').length > 0
	}

	function clearContent () {
		$attrList = []
		component.$children[1].$set(component.$children[1], 'attributeList', [])
		component.$children[1].$set(component.$children[1], 'intermediateAttributeList', [])
	}

	function showForm () {
		$(SELECTOR.form).modal({ backdrop: 'static' })
		$(SELECTOR.multicheckbox + ' .mcb-drop-down-btn').first().focus()
	}

	function hideForm () {
		$(SELECTOR.form).modal('hide')
	}

	function switchEditorArea ($targetCheckbox, $data) {
		if (!$targetCheckbox || !$targetCheckbox.is('input[type=\'checkbox\']')) {
			return false
		}
		var editorAreaId = $targetCheckbox.val()

		if (editorAreaId) {
			if ($targetCheckbox.is(':checked')) {
				$attrList.push(editorAreaId)
				component.$children[1].$set(component.$children[1], 'attributeList', $attrList)
				if ($data.itemStructure[editorAreaId].type === 'A') {
					$('#' + editorAreaId + '__image__area').remove()
					bindImageAttributeEvents(editorAreaId)
				}
				component.$nextTick(function () {
					if ($data.itemStructure[editorAreaId].type === 'D') {
						initDatepicker()
					}
					if ($data.itemStructure[editorAreaId].type === 'L' && $data.itemStructure[editorAreaId].maxCount === -1) {
						disableMulticheckboxSupport({ selector: '#' + editorAreaId + '__area' })
						enableMulticheckboxSupport({ selector: '#' + editorAreaId + '__area' })
						console.log(editorAreaId);
					}
				})

			} else {
				$attrList.splice($attrList.indexOf(editorAreaId), 1)
				component.$children[1].$set(component.$children[1], 'attributeList', $attrList)
			}
		}
	}
}
